// extracted by mini-css-extract-plugin
export default {"modules":"AzgGC","header":"LzuAT","inner":"RVtoP"};